module.exports = __webpack_public_path__ + "img/pizzaria-color.c272f8fa.svg";